export const Mark = ({ className = "h-6 w-6" }: { className?: string }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true" fill="none">
    <path d="M7 6.5h18v9.5H7v9.5h18" stroke="currentColor" strokeWidth="3.5" />
  </svg>
);
